export const SETUP_OPTIONS = {
  SELF: 'F',
  PROFESSIONAL: 'O',
  learnMoreLink: 'Learn more',
  mvaLearnMoreURL: 'https://www.verizon.com/support/verizon-receiver-setup/',
  selfSetupSubtitle:
    'You can place your move as far as 30 days from today. Billing and internet services will be paused on your move out date and will resume on your move in date unless you reconnect sooner.',
  selfSetupTooltipContent: 'Your services restart at 12:01 AM Pacific time on this date or sooner.',
  profSetupTooltipContent: 'Your billing and internet services restart when your professional setup is complete.',
};

export const SELF_SETUP_INFORMATION = {
  heading: 'How to set up your device',
  subHeading: 'Follow easy, step-by-step instructions to set up your home internet equipment. Support is available 24x7.',
  bannerText: 'Please remember to bring all of your home internet equipment to set up at your new address.',
};

export const AEM_FALLBACK = {
  setupOptions: {
    professionalFeeWaiver: '$99 set-up fee waived',
    professionalChargesSubtext: 'Expert technicians at your service',
    selfPricingText: 'Free',
    selfSetupEstimate: 'Estimated setup time: 10-15 mins',
  },
};

export const MINI_CART_FALLBACK = {
  miniCartDueToday: {
    ':type': 'vcg/components/soe-home/react/common/miniCartDueToday',
    titleForShow: 'Due today',
    titleForHide: 'Due Today',
    totalToday: 'Total due today',
    securityDeposit: 'Refundable deposit',
  },
  miniCartDueMonthly: {
    ':type': 'vcg/components/soe-home/react/common/miniCartDueMonthly',
    titleForShow: 'Due monthly',
    titleForHide: 'Due Monthly',
    totalMonthly: 'Total due Monthly',
    taxFeeText: 'Plus applicable taxes and fees.',
    withAutoPayPreview: 'with Auto pay and paper-free billing',
    withAutoPayTooltipDesc:
      'Once you create a Verizon account, you can add a valid bank account or Verizon Visa card and then enroll to get the APO discount. Discount is eligible for valid US addresses only.',
  },
};

export const ProfhelperText = 'Service and billing restarts on this date.';

export const DEFAULT_ERR_MSG = 'Looks like something went wrong. Please try again later.';

export const DATE_SELECT_ERR_MSG = 'Please fill all the fields to continue with your move order.';
